export const VIEWS_CONFIG = [
  {
    name: 1,
    style: {
      gridTemplateColumns: '1fr',
      gridTemplateRows: '1fr',
    },
  },
  {
    name: 2,
    style: {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr',
    },
  },
  {
    name: 3,
    style: {
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: '1fr',
    },
  },
  {
    name: 4,
    style: {
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr 1fr',
    },
  },
];
